export default __webpack_public_path__ + "static/media/dynamite_explosion.b86305f5.mp3";